import { FaCircleCheck } from "react-icons/fa6";

function SuccessTransaction() {
  return (
    <div className="text-center">
      <div className="flex !h-[70vh] flex-col items-center justify-center ">
          <div className="flex !h-[70vh] flex-col items-center   justify-center">
            <h1>
                <FaCircleCheck className="mx-auto text-9xl  text-green-500" />
                <h3 className="0 my-3 font-bold">
                Payment has been Successfully done.
                </h3>
            </h1>
          </div>
      </div>
    </div>
  );
}

export default SuccessTransaction;
